import React from 'react';
import BaseSearchDropdown from './BaseSearchDropdown';

export default class MedicationDropdown extends BaseSearchDropdown {
    constructor(props) {
        super(props);
        this.formatter = ({name}) => name;
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/ContactDropdown.js